var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateModal',{attrs:{"text":_vm.text,"confirmLabel":_vm.confirmLabel,"bottomText":_vm.bottomText},on:{"onConfirm":_vm.action,"onClose":_vm.closeModal,"onCancel":_vm.closeModal}})}
var staticRenderFns = []

export { render, staticRenderFns }